import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsDirectivesModule } from "@app/directives/_forms/_form.directives.module";
import { VTableModule } from "@app/directives/_layout/v-table/v-table.module";
import { MapDirectivesModule } from "@app/directives/_map/_map.directives.module";
import { VehicleDirectivesModule } from "@app/directives/_vehicle/_vehicle.directives.module";
import { ResourceManagementModule } from "@app/main/components/resourceManagement/resourceManagement.module";
import { EngineerCompanyComponent } from "@app/main/modules/foundation/_routes/engineer-users/engineer-company/engineer-company.component";
import { StreamaxConfigsModule } from "@app/main/modules/foundation/_routes/streamax-configs/streamax-configs.module";
import { FoundationAccountService } from "@app/main/modules/foundation/_services/account.service.ajs";
import { DeviceDataValidationService } from "@app/main/modules/foundation/_services/device-data-validation.service";
import { VehicleValidationCheckRecordService } from "@app/main/modules/foundation/_services/vehicle-validation-check-record.service";
import { FoundationVehicleService } from "@app/main/modules/foundation/_services/vehicle.service.ajs";
import { EngineerAssetsService } from "@app/main/modules/foundation/_services/_commissioning/engineer-assets.service";
import { CoreDirectivesModule } from "@directives/_core/_core.directives.module";
import { LayoutDirectivesModule } from "@directives/_layout/_layout.directives.module";
import { ResourceFiltersDirectivesModule } from "@directives/_resourceFilters/_resourceFilters.directives.module";
import { CommissionModule } from "@foundation/_routes/commissions/commission.module";
import { ManualDeviceValidationCheckService } from "@foundation/_services/manual-device-validation-check.service";
import { NotesService } from "@foundation/_services/notes.service.ajs";
import { FoundationPeripheralService } from "@foundation/_services/peripheral.service.ajs";
import { providerCreator } from "@services/_services.module";
import { StateParams, Transition } from "@uirouter/angularjs";
import { PipesModule } from "src/app/_pipes/_pipes.module";
import { MiscDirectivesModule } from "../../../directives/_misc/_misc.directives.module";
import { FoundationComponentsModule } from "./_components/components.modules";
import { CustomerSubscriptionsPageComponent } from "./_routes/customers/customer-subscriptions-page/customer-subscriptions-page.component";
import { CustomerSubscriptionsComponent } from "./_routes/customers/customer-subscriptions/customer-subscriptions.component";
import { FoundationCustomerEditComponent } from "./_routes/customers/customerEdit/customer-edit.component";
import { CustomerOverviewComponent } from "./_routes/customers/customerOverview/customer-overview.component";
import { FoundationCustomersComponent } from "./_routes/customers/customers.component";
import { CustomerViewComponent } from "./_routes/customers/customerView/customer-view.component";
import { CustomerUserList } from "./_routes/customers/userList/user-list.component";
import { JsonDebugViewComponent } from "./_routes/developerConsole/debug-json-view/debug-json-view.component";
import { DeveloperConsoleComponent } from "./_routes/developerConsole/developer-console.component";
import { DeviceHealthAccountsComponent } from "./_routes/device-health/components/device-health-accounts/device-health-accounts.component";
import { DeviceHealthVehicleViewComponent } from "./_routes/device-health/components/device-health-vehicle-view/device-health-vehicle-view.component";
import { DeviceHealthVehiclesComponent } from "./_routes/device-health/components/device-health-vehicles/device-health-vehicles.component";
import { DeviceHealthComponent } from "./_routes/device-health/components/device-health/device-health.component";
import { EngineerCommissionHistoryListComponent } from "./_routes/engineer-commission-history/engineer-commission-history-list.component";
import { EngineerJobItemListModule } from "./_routes/engineer-job-items/engineer-job-item-list.module";
import { EngineerEditorComponent } from "./_routes/engineer-users/engineer-editor/engineer-editor.component";
import { EngineerUsersComponent } from "./_routes/engineer-users/engineer-users-list.component";
import { HardwareModule } from "./_routes/hardware/hardware.module";
import { UnitLogService } from "./_routes/hardware/units/unit-logs/unit-log.service";
import { FoundationJobsModule } from "./_routes/jobs/jobs.module";
import { ReleaseNotesComponent } from "./_routes/release-notes/release-notes.component";
import { RVLiteModule } from "./_routes/rv-lite/rv-lite.module";
import { FoundationVehicleListComponent } from "./_routes/vehicles/vehicle-list.component";
import { VehicleViewComponent } from "./_routes/vehicles/vehicleView/vehicle-view.component";
import { VisitFailuresComponent } from "./_routes/visit-failures/visit-failures.component";
import { FoundationUserService } from "./_services/user.service.ajs";

const privateComponents: any[] = [

];

const publicComponents: any[] = [
    FoundationCustomersComponent,
    EngineerUsersComponent,
    DeveloperConsoleComponent,
    JsonDebugViewComponent,
    EngineerEditorComponent,
    EngineerCompanyComponent,
    CustomerSubscriptionsComponent,
    CustomerSubscriptionsPageComponent,
    ReleaseNotesComponent,
    FoundationVehicleListComponent,
    VehicleViewComponent,
    CustomerOverviewComponent,
    CustomerUserList,
    CustomerViewComponent,
    FoundationCustomerEditComponent,
    DeviceHealthComponent,
    DeviceHealthAccountsComponent,
    DeviceHealthVehiclesComponent,
    DeviceHealthVehicleViewComponent,
    EngineerCommissionHistoryListComponent,
    VisitFailuresComponent
];

const declarations: any[] = [
];

const providers: any[] = [
    providerCreator(FoundationPeripheralService, "foundationPeripheralService"),
    providerCreator(FoundationAccountService, "foundationAccountService"),
    providerCreator(FoundationUserService, "foundationUserService"),
    providerCreator(FoundationVehicleService, "foundationVehicleService"),
    providerCreator(NotesService, "notesService"),
    ManualDeviceValidationCheckService,
    DeviceDataValidationService,
    VehicleValidationCheckRecordService,
    providerCreator(StateParams, '$stateParams'),
    providerCreator(Transition, '$transitions'),
    UnitLogService,
    EngineerAssetsService
];

@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        PipesModule,
        CommissionModule,
        MiscDirectivesModule,
        FormsDirectivesModule,
        ResourceFiltersDirectivesModule,
        FoundationComponentsModule,
        MapDirectivesModule,
        VTableModule,
        LayoutDirectivesModule,
        CoreDirectivesModule,
        FormsModule,
        ReactiveFormsModule,
        VehicleDirectivesModule,
        EngineerJobItemListModule,
        ResourceManagementModule,
        FoundationJobsModule,
        HardwareModule,
        RVLiteModule,
        StreamaxConfigsModule
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class FoundationModule {
    constructor() {
    }
}
